import Instance from "../Helper/axios";
import { URL, URLTEST, urlLocal } from "../Helper/baseURL";

export async function GetRecoveryBarcode(param) {
  try {
    const formData = new FormData();
    Object.entries(param).forEach(([key, value]) => {
      formData.append(key, value);
    });

    const response = await Instance.post(URL + "invoice/Invoice/getRecoveryBarcode", formData);
    return await response.data;
  } catch (error) {
    console.log("error", error);
  }
}